exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ncanvas[data-v-616a602b] {\n\t\tmargin: 1em auto;\n\t\twidth: 100%;\n\t\tmax-height: 60vh;\n\t\ttransition: transform 0.2s;\n        box-shadow: -0.125em 0.125em 0 0 rgb(0 0 0 / 20%);\n\t\tborder-radius: 1em;\n}\n", ""]);

